import TestVariableBlock from './TestVariableBlock';
import { TestVariableBlockProps, TestVariableBlockValueProps } from './types';

export type { TestVariableBlockProps, TestVariableBlockValueProps };
export default TestVariableBlock;
